export function buildDialerRedirectPath(search: string): string {
  const trimmed = search.trim();
  if (!trimmed) return '/dialer';

  return trimmed.startsWith('?') ? `/dialer${trimmed}` : `/dialer?${trimmed}`;
}

export function buildDialerPath(params?: {
  phone?: string | null;
  conversation?: string | null;
  contact?: string | null;
  action?: 'call' | null;
}): string {
  const query = new URLSearchParams();

  const conversation = params?.conversation?.trim();
  if (conversation) query.set('conversation', conversation);

  const contact = params?.contact?.trim();
  if (contact) query.set('contact', contact);

  const phone = params?.phone?.trim();
  if (phone) query.set('phone', phone);

  const action = params?.action?.trim();
  if (action) query.set('action', action);

  const search = query.toString();
  return search ? `/dialer?${search}` : '/dialer';
}
